import React from 'react';
import EmptyState from "@/assets/images/icons/state-empty.svg";

const Index = ({emptyUiText='Список пусто'}) => {
    return (
        <div className="devent-table__no-data">
            <img src={EmptyState} alt=""/>
			{emptyUiText}
        </div>
    );
};

export default Index;
